import { useEffect, useState } from "react";
import { liveTicker } from "@/mocks/hotlist";

export default function LiveTicker() {
  const [clock, setClock] = useState("");

  useEffect(() => {
    const update = () => {
      const now = new Date();
      const hh = String(now.getHours()).padStart(2, "0");
      const mm = String(now.getMinutes()).padStart(2, "0");
      const ss = String(now.getSeconds()).padStart(2, "0");
      setClock(`${hh}:${mm}:${ss}`);
    };
    update();
    const timer = window.setInterval(update, 1000);
    return () => window.clearInterval(timer);
  }, []);

  const items = [...liveTicker, ...liveTicker];

  return (
    <div className="flex items-stretch border border-background-300/60 rounded-lg bg-background-100/60 backdrop-blur-sm overflow-hidden">
      <div className="flex items-center gap-2 px-3 md:px-4 py-3 bg-accent-500/90 shrink-0">
        <span className="w-2 h-2 rounded-full bg-background-50 animate-pulse-dot" />
        <span className="text-xs md:text-sm font-medium text-background-50 whitespace-nowrap">
          实时播报
        </span>
      </div>
      <div className="relative flex-1 overflow-hidden">
        <div className="flex items-center h-full animate-marquee w-max">
          {items.map((text, index) => (
            <span
              key={`${text}-${index}`}
              className="flex items-center gap-2 px-5 text-xs md:text-sm text-foreground-700 whitespace-nowrap"
            >
              <i className="ri-flashlight-fill text-primary-400" />
              {text}
            </span>
          ))}
        </div>
      </div>
      <div className="hidden md:flex items-center gap-2 px-4 border-l border-background-300/60 shrink-0">
        <i className="ri-time-line text-secondary-400" />
        <span className="text-xs font-medium text-foreground-700 tabular-nums">{clock}</span>
      </div>
    </div>
  );
}